import { render } from "./MyFooter.vue?vue&type=template&id=3540c6da&scoped=true"
import script from "./MyFooter.vue?vue&type=script&lang=js"
export * from "./MyFooter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3540c6da"

export default script